import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Home, PieChart, ArrowRightLeft, User, Shield, LogOut } from 'lucide-react';
import AccountSidebar from './AccountSidebar';
import AccountNavbar from './AccountNavbar';

const AccountLayout = ({ children }: { children: React.ReactElement }) => {
  const [userData, setUserData] = useState<any>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { name: 'Home', icon: Home, path: '/account/dashboard' },
    { name: 'Portfolio', icon: PieChart, path: '/account/portfolio' },
    { name: 'Transactions', icon: ArrowRightLeft, path: '/account/transactions' },
    { name: 'Profile', icon: User, path: '/account/profile' },
    { name: 'Security', icon: Shield, path: '/account/security' },
  ];

  useEffect(() => {
    // Register.tsx 'user' save karta hai, isliye hum 'user' check karenge
    const storedUser = localStorage.getItem('user'); 
    
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserData(parsedUser); // Turant purana data dikhao taaki UI load ho jaye

      // SILENTLY BACKEND SE LATEST DATA LAO (Isse balance automatically update ho jayega)
      fetch(`https://motilalalgo.com/api/profile/${parsedUser.id}`)
        .then(res => res.json())
        .then(latestData => {
          if (!latestData.error) {
            setUserData(latestData); // Naya data state me set karo
            localStorage.setItem('user', JSON.stringify(latestData)); // Local Storage me bhi update kar do
          }
        })
        .catch(err => console.error("Failed to fetch live balance:", err));

    } else {
      navigate('/demat/register');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/demat/register');
  };

  if (!userData) {
    return <div className="h-screen bg-[#0b1221] flex items-center justify-center text-blue-500 font-bold">Securely Loading...</div>;
  }

  return (
    <div className="flex h-screen bg-[#050b14] text-white font-sans overflow-hidden">
      <AccountSidebar onLogout={handleLogout} />
      
      <div className="flex-1 flex flex-col h-full overflow-hidden relative">
        <AccountNavbar userData={userData} onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
        
        {isMobileMenuOpen && (
          <div className="absolute top-20 left-0 w-full bg-[#131b2c] border-b border-gray-800 z-50 p-4 md:hidden shadow-2xl flex flex-col gap-2">
            {navItems.map((item) => {
              const isActive = currentPath === item.path;
              return (
                <Link 
                  key={item.name} 
                  to={item.path} 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-all ${isActive ? 'bg-blue-600/10 text-blue-500' : 'text-gray-400 hover:bg-[#1e222d] hover:text-gray-200'}`}
                >
                  <item.icon size={20} /> {item.name}
                </Link>
              );
            })}
            <div className="h-px bg-gray-800 my-2"></div>
            <button onClick={handleLogout} className="flex items-center justify-center gap-2 w-full py-3 text-center text-red-400 font-bold bg-red-500/10 hover:bg-red-500/20 transition-colors rounded-xl">
              <LogOut size={20} /> Logout
            </button>
          </div>
        )}

        <main className="flex-1 overflow-y-auto custom-scrollbar p-4 md:p-8">
          {/* Yahan par children ko latest userData bhej rahe hain */}
          {React.cloneElement(children as React.ReactElement<any>, { userData })}
        </main>
      </div>
    </div>
  );
};

export default AccountLayout;